import { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import {
  Nav
  , Page
  , Content
  , Icon
  , Loading
  , PopUp
} from '@beisen/chaos-ui';
require('./PopTree.scss');

import * as htmlHelper from '../../util/html';
import EmptyIcon from '../../EmptyIcon/EmptyIcon';
import * as urlHelper from '../../util/url';
import { addEnNavClassName } from '../../util/ui';
import {
  ifHidePopupNav,
  generateHeaderConfig,
  clearHeaderConfig,
  ajaxUrlCompletionInCachePage

} from '../../util/helper';

export default class PanelTree extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.clickItem = this.clickItem.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleClear = this.handleClear.bind(this);

    this.state = {
      curDept: []
      , selDept: []
      , pleaseSelectActive: true
      , listHeight: window.innerHeight - 96
      , hasData: 'loading'
    };
    this.lastLevel = false;
    this.openSearch = true;
  }

  handleTouchStart(e) {
    let scrollEl = this.refs.selectList;
    if (scrollEl.scrollWidth > scrollEl.clientWidth) {
      this.originScreenX = e.targetTouches[0].screenX;
      this.originScrollLeft = scrollEl.scrollLeft;
    }
  }

  handleTouchMove(e) {
    let scrollEl = this.refs.selectList;
    if (scrollEl.scrollWidth > scrollEl.clientWidth) {
      scrollEl.scrollLeft = this.originScrollLeft - e.targetTouches[0].screenX + this.originScreenX;
    }
  }

  handleClear(event) {
    event && event.preventDefault && event.preventDefault();
    this.props.onClearValue && this.props.onClearValue();
  }

  handleCancel(event) {
    event && event.preventDefault && event.preventDefault();
    this.props.handleCancel && this.props.handleCancel();
  }

  handleConfirm(event) {
    event && event.preventDefault && event.preventDefault();
    if (this.state.selDept.length == 0) {
      this.props.handleCancel && this.props.handleCancel();
    }
    let index = this.state.selDept.length - 1;
    let lastItem = this.state.selDept[index];

    this.props.handleConfirm && this.props.handleConfirm(lastItem);
  }

  searchData(item, type) {
    let { datasourceUrl, datasourcename, translation } = this.props;
    let { selDept, pleaseSelectActive } = this.state;
    const appName = this.props.cmp_data.applicationName || BSGlobal.application;
    const metaObjName = this.props.cmp_data.metaObjectName || this.props.metaObjName;
    let FetchUrl = '/api/v2/data/datasource/treedatasource?app=' + appName + '&metaObjName=' + metaObjName + '&dataSourceName=' + datasourcename + '&formState=' + this.props.formState;
    let urlParams = 'app=' + appName + '&metaObjName=' + metaObjName + '&type=expand&queryMode=exact&async=true' + '&formState=' + this.props.formState;
    let method = 'GET';
    let parmName = 'id';
    if (datasourceUrl) {
      FetchUrl = datasourceUrl + urlHelper.getConnectSymbol(datasourceUrl) + urlParams;
      method = 'POST';
      parmName = 'value';
    }
    let pid = '';

    if (item && type != 'root') {
      if (type == 'children') {
        this.lastLevel = false;
        this.currentId = '';
        pid = item.id;
        selDept = selDept.filter(Item => {
          return Item.level < item.level && Item.pid != item.pid;
        });
        pleaseSelectActive = true;
        selDept.push(item);
      } else if (type == 'current') {
        this.lastLevel = false;
        this.currentId = item.id;
        pid = item.pid;
        pleaseSelectActive = false;
        selDept = selDept.filter(Item => {
          return Item.level <= item.level;
        });
        selDept.push(item);
      } else if (type == 'lastLevel') {
        selDept = selDept.filter(Item => {
          return Item.level <= item.level && Item.pid != item.pid;
        });
        selDept.push(item);

        this.currentId = item.id;
        pid = item.pid;
        this.setState({ pleaseSelectActive: false, selDept }, () => {
          this.setActive();
        });
        return;
      }
    } else if (type == 'root') {
      selDept = selDept.filter(Item => {
        return Item.level < item.level;
      });
      selDept.push(item);
      this.lastLevel = false;
      this.currentId = item ? item.id : null;
    }

    let params = {};
    params[parmName] = pid;

    let fetchParam;
    if (method === 'GET') {
      fetchParam = {};
      const conParam = urlHelper.getConnectSymbol(FetchUrl);
      FetchUrl = FetchUrl + conParam + urlHelper.serializeUrl(params);
    } else {
      fetchParam = {
        body: JSON.stringify(params),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      };
    }
    const successCallBack = function(response) {
      let datas = response.Data;
      if (datas.length === 0 && item == undefined) {
        this.setState({ hasData: false });
        return;
      }
      this.setState({ hasData: true });
      //has_child有时不准
      if (datas.length === 0) {
        this.searchData(item, 'lastLevel');
        return;
      }
      // 点击某个部门请求回来的就是它的下级数据 没有下下级的 不需要过滤
      let dataArr = [];
      let selItem = item;
      for (let i = 0; i < datas.length; i++) {
        let item = datas[i];
        if (!selItem) {
          if (dataArr.length > 0 && item['level'] < dataArr[0]['level']) {
            dataArr = [];
          }
          dataArr.push(item);
          continue;
        }
        if (type == 'children') {
          if (selItem['id'] == item['pid']) {
            dataArr.push(item);
          }
        } else if (type == 'current') {
          if (selItem['pid'] == item['pid']) {
            dataArr.push(item);
          }
        } else if (type == 'root') {
          if (selItem['pid'] == item['pid'] && selItem['level'] == item['level']) {
            dataArr.push(item);
          }
        }
      }

      this.setState({
        curDept: dataArr
        , selDept
        , pleaseSelectActive
      }, () => {
        this.setActive();
      });
    }.bind(this);

    const failureCallBack = function(error) {
      let tipInfo = { message: error.message || translation.dataFaildTip, type: 'error' };
      if (error.isOffLine) {
        error['type'] = 'error';
        tipInfo = error;
      }
      this.props.showTip(tipInfo);
    }.bind(this);
    FetchUrl = ajaxUrlCompletionInCachePage(FetchUrl);
    window.CommonFetch && window.CommonFetch(FetchUrl, fetchParam, successCallBack, failureCallBack);
  }


  //设置壳子的导航对象并通知壳子更新导航
  setBoxHeader() {
    const { translation } = this.props;
    let title = this.props.title;
    generateHeaderConfig(function(headerConfig, setButton) {
      let config = Object.assign({}, headerConfig);
      const left_item = [
        {
          callback: 'panelTreeClose',
          control: true,
          text: '',
          type: 'back'
        },
        {
          icon: '',
          callback: 'panelTreeClear',
          control: true,
          text: translation.clear,
          type: 'text'
        }
      ];
      config = setButton('left', left_item, config);
      const right_item = [
        {
          icon: '',
          callback: 'panelTreeConfirm',
          control: true,
          text: translation.confirm,
          type: 'text'
        }
      ];
      config = setButton('right', right_item, config);
      if (title) {
        config.titleItem = {
          text: title,
          icon: '',
          callback: '',
          control: false
        };
      }
      return config;
    });
  }

  //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
  getPreHeaderConfig() {
    clearHeaderConfig();
  }

  //注册壳子回调函数
  registCallback() {
    window.globalEventManager = window.globalEventManager || {};
    window.globalEventManager['panelTreeClose'] = this.handleCancel.bind(this);
    window.globalEventManager['panelTreeClear'] = this.handleClear.bind(this);
    window.globalEventManager['panelTreeConfirm'] = this.handleConfirm.bind(this);
  }

  //清除壳子回调函数
  clearCallback() {
    delete window.globalEventManager['panelTreeClose'] && delete window.globalEventManager['panelTreeClear'] && delete window.globalEventManager['panelTreeConfirm'];
  }

  componentDidMount() {
    setTimeout(() => {
      this.searchData();
    }, 300);
    if (ifHidePopupNav() && this.props.pop_type !== 'searchList') {
      this.registCallback();
      this.setBoxHeader();
    }
  }

  componentWillUnmount() {
    if (ifHidePopupNav() && this.props.pop_type !== 'searchList') {
      this.clearCallback();
      this.getPreHeaderConfig();
    }
  }

  //点击已选择的部门
  selectItem(index, event) {
    event.preventDefault();
    let curItem = this.state.selDept.find(item => {
      return item.id == event.target.getAttribute('data-id');
    });
    if (index == 0) {
      this.searchData(curItem, 'root');
    } else if (curItem) {
      this.searchData(curItem, 'current');
    }
  }

  //显示已选择部门
  renderSelectDept() {
    return this.state.selDept.map((item, index) => {
      return (
        <span key={item.id} className={classNames('sel-dept-item', { 'selected': item.id === this.currentId })} data-id={item.id} onTouchTap={this.selectItem.bind(this, index)}
          dangerouslySetInnerHTML={{ __html: item.name }}
        />

      );
    });
  }

  //点击请求的子部门
  clickItem(event) {
    if (window.env.platform.bsAppIOS) {
      // 解决apicloud中点击有下级数据，滚动条不置顶问题
      const transformForTreeOrg = document.getElementsByClassName('transformForTreeOrg')[0];
      transformForTreeOrg.style.transform = 'translateY(0px)';
      transformForTreeOrg.style.WebkitTransform = 'translateY(0px)';

      setTimeout(() => {
        transformForTreeOrg.style.transform = 'translateY(1px)';
        transformForTreeOrg.style.WebkitTransform = 'translateY(1px)';
      });
    }
    event.preventDefault();
    let curItem = this.state.curDept.find(item => {
      return item.id == event.target.getAttribute('data-id');
    });
    if (!this.openSearch) {//this.openSearch这个参数目的是为了防止连续点击出现数据显示不正确的问题，因为searchData里面是异步请求需要请求完才允许有下次操作
      return;
    }
    this.openSearch = false;
    if (curItem && curItem.has_child == true) {
      this.refs.deptlist.scrollTop = 0;
      this.searchData(curItem, 'children');
    } else if (curItem && curItem.has_child == false) {
      this.searchData(curItem, 'lastLevel');
    }
  }

  renderDept() {
    return this.state.curDept.map(item => {
      return (
        <div key={item.id} className={classNames('dept-item border-1px border-b', { 'selected': item.id === this.currentId })} data-id={item.id} onTouchTap={this.clickItem}
        >
          {htmlHelper.decode(item.name)}
          {item.id === this.currentId ? <Icon icon='m-sys-singlebox' size='small' /> : null}
        </div>
      );
    });
  }
  setActive() {
    let activeEl = this.refs.selectList && this.refs.selectList.getElementsByClassName('selected')[0];
    if (activeEl) {
      let clientRect = activeEl.getBoundingClientRect();
      this.refs.activeBar.style.cssText = 'width: ' + (clientRect.width - 18) + 'px;left:' + activeEl.offsetLeft + 'px';
    }

    let scrollEl = this.refs.selectList && this.refs.selectList;
    if (scrollEl) {
      if (scrollEl.scrollWidth > scrollEl.clientWidth) {
        scrollEl.scrollLeft = scrollEl.scrollWidth;
      }
    }
    this.openSearch = true;
  }

  renderTreePage() {
    const { translation } = this.props;
    let { pleaseSelectActive } = this.state;
    let content = (<Content>
      <div className='clearButton' onTouchTap={this.handleClear}>{translation.clear}</div>
      <div className='dept-select' ref='selectList' onTouchStart={this.handleTouchStart} onTouchMove={this.handleTouchMove}>
        <span className="active-bar" ref='activeBar'></span>
        {this.renderSelectDept()}
        {pleaseSelectActive ? <span className='selected' style={{ color: '#007ed9' }}>{translation.select}</span> : ''}
      </div>
      <div className='dept-sep border-1px' />
      <div className="transformForTreeOrg" />
      <div className='dept-list' ref='deptlist' style={{ height: this.state.listHeight }}>
        {this.renderDept()}
      </div>
    </Content>);
    if (this.state.hasData) {
      return content;
    }
    const deptContainerHeight = this.refs.deptPage && ReactDOM.findDOMNode(this.refs.deptPage).offsetHeight || 0;
    const deptNavHeight = this.deptNav && ReactDOM.findDOMNode(this.deptNav).offsetHeight || 0;
    return (<EmptyIcon containerHeight={deptContainerHeight - deptNavHeight}
      num={1}
    />);
  }

  render() {
    const { translation } = this.props;
    const style = this.props.pop_type == 'searchList' ? { width: '85%', left: '15%' } : {};
    const animation = this.props.pop_type == 'searchList' ? 'right-slide-fade' : 'bottom-slide-fade';
    let navStyle = ifHidePopupNav() && this.props.pop_type !== 'searchList' ? { display: 'none' } : {};

    const enNavButtonClass = addEnNavClassName();
    return (
      <PopUp visible={this.props.visible}
        animation={animation}
        maskAnimation="fade"
        cls='paneltree_popup'
        style={style}
        onClose={this.handleCancel}
        ref='popUp'
        afterClose={this.props.afterClose}
      >
        <Page cls='dept-page clear' ref="deptPage">
          <Nav title={this.props.title} navRef={el => this.deptNav = el} style={navStyle}>
            <div role='left'>
              <a href='javascript:;' className={enNavButtonClass} onTouchTap={this.handleCancel}>{translation.cancel}</a>
            </div>
            <a href='javascript:;' className={enNavButtonClass} onTouchTap={this.handleConfirm} role='right'>{translation.confirm}</a>
          </Nav>
          {this.state.hasData === 'loading' ? <Loading /> : this.renderTreePage()}
        </Page>
      </PopUp>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopTree/PanelTree.js